import { useToastStore } from '../../store/toastStore'
import styles from './Toaster.module.css'

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts)
  const dismiss = useToastStore((s) => s.dismiss)

  if (toasts.length === 0) return null

  return (
    <div className={styles.stack}>
      {toasts.map((t) => (
        <div key={t.id} className={[styles.toast, styles[t.variant]].join(' ')} onClick={() => dismiss(t.id)}>
          {t.message}
        </div>
      ))}
    </div>
  )
}
